<template>
  <div>
    <v-menu>
      <template v-slot:activator="{ on: menu }">
        <template>
          <v-btn
            class="color-icon button-dropdown"
            depressed
            rounded
            block
            v-on="{ ...menu }"
          >
            <!-- eslint-disable-next-line max-len -->
            <media-icon class="pe-2" :link="selected ? selected.name : emptyItem.name"></media-icon>
            {{ truncatedTitle(selected ? selected.name : emptyItem.name) }}
            <v-icon right dark>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
      </template>

      <v-list>
        <v-list-item v-for="(item, index) in selectItems" :key="index" @click="change(item, index)">
          <v-list-item-title
            class="button-dropdown__title"
            style="
            display:flex !important;
            flex-direction: row !important;
            align-items: center !important;"
          >
            <media-icon class="pe-2" :link="item.name"></media-icon>
            {{ menuTruncatedTitle(item.name) }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>


<script>
import truncate from 'lodash/truncate';

import mediaIcon from '@/components/MediaIcon.vue';

export default {
  name: 'ButtonDropdown',
  components: {
    mediaIcon,
  },
  props: ['selected', 'media'],
  data: () => ({}),
  computed: {
    selectItems() {
      const links = [];
      this.media.links.map(link => {
        links.push({ link, name: link, type: 'link' });
        return true;
      });

      const files = [];
      this.media.files.map(file => {
        files.push({ link: file.link, name: file.name, type: 'file' });
        return true;
      });

      return [this.emptyItem, ...files, ...links];
    },
    emptyItem() {
      return { name: this.$t('notSelected'), link: '' };
    },
  },
  methods: {
    truncate,
    unselect() {
      this.$emit('unselect');
    },
    change(item, index) {
      if (index > 0) this.$emit('select', item);
      else this.unselect();
    },
    truncatedTitle(value) {
      return truncate(value, {
        length: 23,
        separator: ' ',
      })
        .replace('http://', '')
        .replace('https://', '')
        .replace('www.', '');
    },
    menuTruncatedTitle(title) {
      return title
        .replace('http://', '')
        .replace('https://', '')
        .replace('www.', '');
    },
  },
};
</script>

<style lang="scss" scoped>
.button-dropdown {
  min-width: 280px !important;
  height: 56px !important;
}
@media only screen and (max-width: 1430px) and (min-width: 1290px) {
  .button-dropdown {
    width: 220px !important;
    min-width: 0px !important;
  }
}
@media only screen and (max-width: 1289px) and (min-width: 1025px) {
  .button-dropdown {
    width: 200px !important;
    min-width: 0px !important;
  }
}

@media (max-width: 1024px) {
  .button-dropdown {
    width: 200px !important;
    min-width: 0px !important;
    height: 46px !important;
  }
}

@media (max-width: 1440px) {
  .button-dropdown {
    height: 46px !important;
  }
}
svg {
  width: 20px;
  height: 20px;
}
</style>
